import React from "react";

interface NoDataDisplayProps {
  message: string;
  altText?: string;
}

const NoDataDisplay: React.FC<NoDataDisplayProps> = ({
  message,
  altText = "Not Found",
}) => {
  return (
    <div className="no-data-display">
      <img src="/Icons/no-data.gif" alt={altText} className="no-data-image" />
      <p className="no-data-message">{message}</p>
    </div>
  );
};

export default NoDataDisplay;
